<template>
  <div class="alarm-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-select
            v-model="form.type"
            placeholder="操作类型"
            clearable
            style="width: 160px"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            style="margin-left: 16px"
            @click="initPageData"
            >搜索</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="modul"
          label="操作模块"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="type" label="操作类型" align="center">
        </el-table-column>
        <el-table-column
          prop="ip"
          label="请求地址"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="uri"
          label="请求URL"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="userName" label="操作人" align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="时间"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="操作内容"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                @click="readClick(scope.row.logId)"
                v-hasPermi="['日志管理', '详情']"
                >查看</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { queryOperationLogList } from '@/api/logger'
export default {
  data () {
    return {
      form: {
        type: '',
        userId: ''
      },
      loading: false,
      options: [
        { label: '全部', value: 1 }
      ],
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      },
      typeOptions: [{ id: "查询", name: "查询" },
      { id: "新增", name: "新增" },
      { id: "删除", name: "删除" },
      { id: "修改", name: "修改" },]

    }
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
    this.initPageData()
  },
  methods: {
    initPageData () {
      this.loading = true
      const params = { pageNo: this.table.currentPage, pageSize: this.table.size }
      this.form.type ? params.type = this.form.type : ''
      this.form.userId ? params.userId = this.form.userId : ''
      queryOperationLogList(params).then(res => {
        this.loading = false
        this.table.total = res.data.total
        this.table.data = res.data.list
        this.$refs.tables.bodyWrapper.scrollTop = 0;
      })
    },
    currentChange () {
      this.initPageData()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.initPageData()
    },
    readClick (id) {
      this.$router.push({ name: 'detail', query: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
.alarm-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .type {
      .iconfont {
        display: inline-block;
        width: 40px;
        text-align: center;
        color: #f00;
      }
    }
    .status {
      &.red {
        color: #f00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.alarm-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
